module.exports = __webpack_public_path__ + "static/img/card-bg.4bdc32a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/changeCoures/card-bg.png
// module id = CM+w
// module chunks = 167